interface TabPanelProps {
  children: React.ReactElement;
  currentValue: number;
  value: number;
}

function TabPanel({ children, value, currentValue }: TabPanelProps) {
  if (currentValue !== value) {
    return null;
  }

  return children;
}

export default TabPanel;
